import { render, staticRenderFns } from "./OnneCardApresentacao.vue?vue&type=template&id=db77bbb4&scoped=true&"
import script from "./OnneCardApresentacao.vue?vue&type=script&lang=js&"
export * from "./OnneCardApresentacao.vue?vue&type=script&lang=js&"
import style0 from "./OnneCardApresentacao.vue?vue&type=style&index=0&id=db77bbb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db77bbb4",
  null
  
)

export default component.exports